import { BaseHealthCardParser } from "./BaseHealthCardParser";

export class MexicoCardParser extends BaseHealthCardParser {
    private OneDimensionRegex = /^([aA-zZ]{4})(\d{6})([aA-zZ]{6})(\d{2})$/;
    private TwoDimensionRegex = [];

    protected GetOneDimensionRegex(): RegExp {
        return this.OneDimensionRegex;
    }

    protected GetTwoDimensionRegex(): RegExp[] {
        return this.TwoDimensionRegex;
    }
}



// WEBPACK FOOTER //
// ./src/services/HealthCardBarcodeScanParsers/MexicoCardParser.ts